module.exports = __webpack_public_path__ + "img/outcome_good.1288b486.jpeg";